import { MenuLayerLevel } from '../types';

import styles from './LeftMenu.module.scss';

export const activeLevelStyles: Record<MenuLayerLevel, string> = {
  0: styles.activeLevel0,
  1: styles.activeLevel1,
  2: styles.activeLevel2,
  3: styles.activeLevel3,
};

export const hoveredLevelStyles: Record<MenuLayerLevel, string> = {
  0: styles.hoveredLevel0,
  1: styles.hoveredLevel1,
  2: styles.hoveredLevel2,
  3: styles.hoveredLevel3,
};
